export const GET = Object.freeze({
  REQUEST: 'standardEquipmentCategory/GET_REQUEST',
  SUCCESS: 'standardEquipmentCategory/GET_SUCCESS',
  ERROR: 'standardEquipmentCategory/GET_ERROR',
});

export const GET_BY_ORGANIZATION_ID = Object.freeze({
  REQUEST: 'standardEquipmentCategory/GET_BY_ORGANIZATION_ID_REQUEST',
  SUCCESS: 'standardEquipmentCategory/GET_BY_ORGANIZATION_ID_SUCCESS',
  ERROR: 'standardEquipmentCategory/GET_BY_ORGANIZATION_ID_ERROR',
});

export const FIND = Object.freeze({
  REQUEST: 'standardEquipmentCategory/FIND_REQUEST',
  SUCCESS: 'standardEquipmentCategory/FIND_SUCCESS',
  ERROR: 'standardEquipmentCategory/FIND_ERROR',
});

export const CREATE = Object.freeze({
  REQUEST: 'standardEquipmentCategory/CREATE_REQUEST',
  SUCCESS: 'standardEquipmentCategory/CREATE_SUCCESS',
  ERROR: 'standardEquipmentCategory/CREATE_ERROR',
});

export const UPDATE = Object.freeze({
  REQUEST: 'standardEquipmentCategory/UPDATE_REQUEST',
  SUCCESS: 'standardEquipmentCategory/UPDATE_SUCCESS',
  ERROR: 'standardEquipmentCategory/UPDATE_ERROR',
});

export const DELETE = Object.freeze({
  REQUEST: 'standardEquipmentCategory/DELETE_REQUEST',
  SUCCESS: 'standardEquipmentCategory/DELETE_SUCCESS',
  ERROR: 'standardEquipmentCategory/DELETE_ERROR',
});

export const GET_EQUIPMENT_CATEGORIES_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: GET.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: GET.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: GET.ERROR,
    payload,
    error: true,
  }),
});

export const GET_EQUIPMENT_CATEGORIES_BY_ORGANIZATION_ID_ACTION = Object.freeze(
  {
    REQUEST: (payload) => ({
      type: GET_BY_ORGANIZATION_ID.REQUEST,
      payload,
    }),
    SUCCESS: (payload) => ({
      type: GET_BY_ORGANIZATION_ID.SUCCESS,
      payload,
      error: false,
    }),
    ERROR: (payload) => ({
      type: GET_BY_ORGANIZATION_ID.ERROR,
      payload,
      error: true,
    }),
  }
);

export const FIND_EQUIPMENT_CATEGORY_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: FIND.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: FIND.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: FIND.ERROR,
    payload,
    error: true,
  }),
});

export const CREATE_EQUIPMENT_CATEGORY_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: CREATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: CREATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: CREATE.ERROR,
    payload,
    error: true,
  }),
});

export const UPDATE_EQUIPMENT_CATEGORY_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: UPDATE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: UPDATE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: UPDATE.ERROR,
    payload,
    error: true,
  }),
});

export const DELETE_EQUIPMENT_CATEGORY_ACTION = Object.freeze({
  REQUEST: (payload) => ({
    type: DELETE.REQUEST,
    payload,
  }),
  SUCCESS: (payload) => ({
    type: DELETE.SUCCESS,
    payload,
    error: false,
  }),
  ERROR: (payload) => ({
    type: DELETE.ERROR,
    payload,
    error: true,
  }),
});
